/**
 * @packageDocumentation
 * @module f1/is
 */

export interface IsRecord {
  /**
   * Checks if an object inherits directly from `null` or `Object.prototype` – like an object literal (`{...}`) does.
   *
   * @public
   * @function f1.is.record
   * @example
   *
   * ```ts
   * f1.is.record({}) => true
   * f1.is.record(Object.create(null)) => true
   *
   * f1.is.record(null) => false
   * f1.is.record([]) => false
   * f1.is.record(/anything else/) => false
   *
   * ```
   */
  (value: unknown): value is Record<string, unknown>;
}

/**
 * @see IsRecord
 */
export default (value: unknown): value is Record<string, unknown> => {
  return value && typeof value === 'object' && value.constructor === Object;
};
